// src/pages/NotFound.jsx
import React from "react";
import Section from "../components/Section";
import { Link } from "react-router-dom";
export default function NotFound(){
  return (
    <Section title="Page not found" subtitle="Let’s get you back on track.">
      <Link to="/" className="btn btn-primary">Go Home</Link>
    </Section>
  );
}
